import React, { memo } from "react";
import styled from "styled-components";

interface IMenuOfferWrapperProps {
  children: Array<JSX.Element>;
}

export const SectionWrapper = styled.div`
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  width: fit-content;
  padding: 2px;
  margin-bottom: 32px;
  background-color: ${(props) => props.theme.backgroundTransparentWhite};
  border-radius: 0 8px 8px 8px;

  &:after {
    content: "";
    flex: auto;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`;

const Wrapper = (props: IMenuOfferWrapperProps) => {
  return <SectionWrapper>{props.children}</SectionWrapper>;
};

export const MenuOfferWrapper = memo(Wrapper);
